import { useCallback, useEffect, useRef } from 'react'

type PreservedPageProps = {
  page: 'home' | 'demo' | 'integrations' | 'about'
  title: string
}

const preservedPageVersion = '20260728-site-scroll-v9'

export default function PreservedPage({ page, title }: PreservedPageProps) {
  const frameRef = useRef<HTMLIFrameElement>(null)
  const initialPage = useRef(page)

  const syncPage = useCallback(() => {
    frameRef.current?.contentWindow?.postMessage(
      { type: 'roadstack:set-page', page },
      window.location.origin,
    )
  }, [page])

  useEffect(() => {
    syncPage()
  }, [syncPage])

  return (
    <main className="preserved-page">
      <iframe
        ref={frameRef}
        className="preserved-frame"
        src={`/preserved/${initialPage.current}.html?v=${preservedPageVersion}`}
        title={title}
        allow="fullscreen"
        onLoad={syncPage}
      />
    </main>
  )
}
